import type { ConfigGroupItem } from './config-group-item';

export class ConfigGroupConfig<T> {
  id: string;
  items: ConfigGroupItem<T>[];
  robotDefinitionId: string;
}
